import { Dispatch, bindActionCreators } from 'redux';
import { Account, AccountStateProps, AccountDispatchProps, AccountOwnProps } from '../components/account/Account';

import { RootState } from '../redux/types';
import { connect } from 'react-redux';
import { onPageDidMount, onPageWillUnmount } from '../redux/core';
import { toast } from '../redux/message/actions';
import { editUserAccount } from '../redux/create-visit/cart/actions';
import { clearError } from '../redux/create-visit/patient/actions';
import { withRouter } from '../util/Router';

export function mapStateToProps(state: RootState): AccountStateProps {
  return {
    isUpdating: state.createVisit.cart.isUpdating,
  };
}

export function mapDispatchToProps(dispatch: Dispatch): AccountDispatchProps {
  return {
    actions: bindActionCreators(
      {
        onPageDidMount,
        onPageWillUnmount,
        editUserAccount,
        clearError,
        toast,
      },
      dispatch
    ),
  };
}

export const AccountContainer = withRouter(connect<AccountStateProps, AccountDispatchProps, AccountOwnProps, RootState>(mapStateToProps, mapDispatchToProps)(Account));
